<template>
	<div>
		<van-field autocomplete="off" required :value="companyName" @input="$emit('update:companyName',$event);$emit('input','');" :placeholder="label?label:(companyType==1?$t('csqxzbm'):$t('csqtxqymc'))" :label="label?label:(companyType==1?$t('csnbbm'):$t('csqymc'))" label-width="90" readonly @click="inputClick" rows="1" autosize type="textarea" maxlength="100">
			<template #label v-if="isAdd||isDelete">
				{{label?label:(companyType==1?$t('csnbbm'):$t('csqymc'))}}
				<van-icon v-if="isDelete" name="minus"class="interest_van_icon" color="#4D9EFF" @click.stop="$emit('delete')"/>
				<van-icon v-else-if="isAdd" name="plus"class="interest_van_icon" color="#4D9EFF" @click.stop="$emit('add')"/>
			</template>
		</van-field>
		<van-field v-if="companyType!=1" autocomplete="off" :value="value" readonly @input="$emit('input',$event)" :placeholder="$t('cstxqymchdjsszddc')" :label="$t('csxydm')" label-width="70"/>
		<van-popup v-model="orgSelectShow" round position="bottom" get-container="body" class="org_popup_mobile">
			<van-cascader value="value" @input="$emit('input',$event)" :title="$t('csqxzbm')" :options="orgOptions" @close="orgSelectShow=false" @finish="orgSelectFinish" :field-names="{text:'name',value:'id',children:'children'}"/>
		</van-popup>
		<el-dialog :title="$t('csqxzbm')" :visible.sync="pcOrgDialogVisible" width="400px" append-to-body :close-on-click-modal="false" custom-class="org_select_dialog" @close="pcOrgDialogVisible=false">
			<el-cascader v-model="pcOrgValue" :options="orgOptions" :props="{value:'id',label:'name',children:'children'}" @change="pcOrgChange" style="width:100%;" clearable placeholder="请选择部门"/>
		</el-dialog>
		<!-- PC端弹框 -->
		<el-dialog :title="$en('选择企业')" :visible.sync="pcDialogVisible" width="600px" append-to-body :close-on-click-modal="false" custom-class="company_select_dialog">
			<el-input v-model="queryKeyWord" :placeholder="$en('模糊搜索')" size="medium" @keyup.enter.native="searchList()" style="margin-bottom:16px;">
				<el-button slot="append" icon="el-icon-search" @click="searchList()"></el-button>
			</el-input>
			<div class="company_select_dialog_list">
				<table class="company_select_list_pc">
					<thead>
						<tr>
							<th width="40px"></th>
							<th style="text-align:left;">{{$en('企业名称')}}</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(item,index) in companyList" @click="companyClick(index,item)" class="company_select_row">
							<td width="40px">
								<div class="pc_company_checkbox" :class="{'is-checked': item.isSelect}">
									<i v-if="item.isSelect" class="el-icon-check"></i>
								</div>
							</td>
							<td style="text-align:left;">{{item.name}}</td>
						</tr>
						<tr v-if="!companyList||companyList.length==0" class="company_select_empty">
							<td colspan="2" style="text-align:center;color:#999;">{{$en('暂无数据，请重新输入查询条件')}}</td>
						</tr>
						<tr v-else-if="hasMore" @click="searchList(curSkip+10)" class="company_select_more">
							<td colspan="2" style="text-align:center;color:#409eff;cursor:pointer;">{{$en('点击加载更多')}}</td>
						</tr>
					</tbody>
				</table>
			</div>
		</el-dialog>
		<!-- 移动端全屏面板 -->
		<div v-show="companySelectShow" class="company_select_plan company_select_mobile body_show_destroy" ref="company_select_plan">
			<van-nav-bar :title="$en('选择企业')" :left-text="$en('关闭')" left-arrow @click-left="closeClick"/>
			<van-field v-model="queryKeyWord" :placeholder="$en('模糊搜索')" left-icon="search">
				<template #button>
					<van-icon name="search"class="interest_van_icon" color="#4D9EFF" @click.stop="searchList()"/>
				</template>
			</van-field>
			<div style="width:100%;max-height:calc(100% - 90px);overflow: auto;">
				<table class="company_select_list">
					<tr v-for="(item,index) in companyList" @click="companyClick(index,item)">
						<td width="40px">
							<div class="cell center">
								<van-checkbox v-model="item.isSelect"/>
							</div>
						</td>
						<td width="100%" style="text-align: left;">
							<div class="cell">
								{{item.name}}
							</div>
						</td>
					</tr>
					<tr style="color:rgb(153, 153, 153);" v-if="!companyList||companyList.length==0">
						<td>
							<div class="cell center">
								{{$en('暂无数据，请重新输入查询条件')}}
							</div>
						</td>
					</tr>
					<tr style="color:rgb(153, 153, 153);" v-else-if="hasMore" @click="searchList(curSkip+10)">
						<td colspan="2">
							<div class="cell center">
								{{$en('点击加载更多')}}
							</div>
						</td>
					</tr>
				</table>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	data(){
		return {
			orgValue:'',
			orgSelectShow:false,
			orgOptions:[],
			companySelectShow:false,
			companyList:[],
			curSkip:0,
			hasMore:false,
			queryKeyWord:'',
			queryTime:0,
			bodySelect:null,
			isPC: window.innerWidth >= 769,
			pcDialogVisible:false,
			pcOrgDialogVisible:false,
			pcOrgValue:[]
		}
	},
	inject:{
		vanForm:{
			default:''
		}
	},
	props:{
		readonly:{
			type:Boolean,
			default(){
				return false
			}
		},
		// 企业类型 0：默认(内部与外部) 1：内部 2：外部
		companyType:{
			type:Number,
			default(){
				return 2
			}
		},
		label:{
			type:String,
			default(){
				return ''
			}
		},
		isAdd:{
			type:Boolean,
			default(){
				return false
			}
		},
		isDelete:{
			type:Boolean,
			default(){
				return false
			}
		},
		value:{
			type:String,
			default(){
				return ''
			}
		},
		companyName:{
			type:String,
			default(){
				return ''
			}
		},
	},
	created(){
	},
	computed:{
		isReadonly(){
			return this.readonly || (this.vanForm || {}).readonly;
		}
	},
	watch:{
		companyType:{
			handler(val){
				this.$emit('input','')
				// this.$emit('update:companyName','')
			}
		},
		value:{
			handler(){
				this.initDef()
			}
		}
	},
	beforeDestroy(){
		if(this.companySelectShow){
			this.companySelectShow = false
		}
	},
	methods:{
		closeClick(){
			this.companySelectShow=false
			this.pcDialogVisible=false
			if(!this.isPC){
				this.$router.go(-1)
			}
		},
		debounceQuerySelect(){
			let curTime = new Date().getTime()
			setTimeout(()=>{
				console.log(curTime,this.queryTime)
				if(curTime==this.queryTime){
					this.searchList()
				}
			},500)
			this.queryTime = curTime
		},
		getSelect(){
			return this.companyList.filter(item=>{
				return item.isSelect
			})
		},
		companyClick(index,item){
			let curSelect = item.isSelect?false:true
			if(!this.multiple){
				let lastSelect = this.companyList[index].isSelect?true:false
				if(!lastSelect){
					this.companyList.map(itm=>{
						itm.isSelect = false
					})
				}
			}
			this.$set(this.companyList[index],'isSelect',curSelect)
			this.$forceUpdate()
			this.$emit('input',this.getSelect().map(item=>{
				return item.credit_no
			}).join(','))
			this.$emit('update:companyName',curSelect?item.name:'')
			this.$emit('select',curSelect?item:{})
			setTimeout(()=>{
				this.closeClick()
			},300)
		},
		inputClick(){
			if(this.companyType==1){
				this.search()
			}else{
				this.searchList()
				if(this.isPC){
					this.pcDialogVisible = true
				}else{
					this.bodySelect = document.body.appendChild(this.$refs.company_select_plan);
					this.companySelectShow = true
					if(!this.$route.query.body_destroy){
						this.$router.push({path:this.$route.path,query:{body_destroy:true}})
					}
				}
			}
		},
		searchList(skip=0){
			this.curSkip=skip
			if(!this.queryKeyWord&&!this.value){
				this.companyList = []
				return
			}
			this.$http.get('/api/model/qxb/getListByCompanyName?name='+(this.queryKeyWord?this.queryKeyWord:this.value)+"&skip="+skip)
			.then(res=>{
				if(skip==0){
					this.companyList = res.data.items
				}else{
					this.companyList.push(...res.data.items)
				}
				if(this.curSkip<res.data.total-10){
					this.hasMore = true
				}else{
					this.hasMore = false
				}
				this.initDef()
			})
		},
		initDef(){
			if(this.value){
				this.companyList.map(item=>{
					if(this.value.indexOf(item.credit_no)>-1){
						item.isSelect = true
					}
				})
			}
		},
		search(){
			if(this.companyType==1){
				this.showOrgSelect()
				return
			}
			if(!this.companyName){
				this.Dialog.alert({
					title:this.$en('警告'),
					message:this.$en('请填写企业名称后再搜索')
				})
				return
			}
			this.$http.get('/api/model/qxb/getInfoByCompanyName?name='+this.companyName)
			// this.$http.get('/api/model/qxb/getInfoByCompanyName?name=广东华三行建工物联科技有限公司')
				.then(res=>{
					let company = res.data
					if(company.creditNo){
						if(this.companyName!=company.name){
							this.Dialog.confirm({
								title:this.$en('提醒'),
								message:this.$en('搜索出来的企业是您输入的企业？'),
								cancelButtonText:this.$en('不是'),
								confirmButtonText:this.$en('是')
							}).then(()=>{
								this.$emit('input',company.creditNo)
								this.$emit('update:companyName',company.name)
							}).catch(()=>{
								this.$message.error(this.$en('请您输入企业全称搜索!!!'))
							})
						}else{
							this.$emit('input',company.creditNo)
							this.$emit('update:companyName',company.name)
							this.$message.success(this.$en('企业搜索成功'))
						}
					}else{
						this.$emit('input','')
						this.Dialog.alert({
							title:this.$en('警告'),
							message:this.$en('未找到公司，请输入企业全名。')
						})
					}
				})
		},
		showOrgSelect(){
			if(!this.orgOptions||this.orgOptions.length<1){
				this.$http.get('/api/orgPerson/v0.1/org/getOrgTreeList?parentId=50020020')
				.then(res=>{
					this.orgOptions = res.data.data[0].children
					if(this.isPC){
						this.pcOrgDialogVisible = true
					}else{
						this.orgSelectShow = true
					}
				})
			}else{
				if(this.isPC){
					this.pcOrgDialogVisible = true
				}else{
					this.orgSelectShow = true
				}
			}
		},
		pcOrgChange(val){
			if(val&&val.length>0){
				let selectedId = val[val.length-1]
				let selectedName = ''
				let findName = (options,id)=>{
					for(let opt of options){
						if(opt.id==id){
							selectedName = opt.name
							return
						}
						if(opt.children){
							findName(opt.children,id)
						}
					}
				}
				findName(this.orgOptions,selectedId)
				this.$emit('input',selectedId)
				this.$emit('update:companyName',selectedName)
				this.pcOrgDialogVisible = false
			}
		},
		orgSelectFinish({selectedOptions}){
			let selectd = selectedOptions[selectedOptions.length-1]
			this.$emit('input',selectd.id)
			this.$emit('update:companyName',selectd.name)
			this.orgSelectShow = false
		}
	}
}
</script>
<style scoped>
	.interest_van_icon{
		font-weight: 800;
	}
	.company_select_plan{
		position:fixed;
		height:100%;
		width:100%;
		background:#dce7f9;
	}
	.company_select_list{
		border-collapse: collapse;
		width:100%;
	}
	.company_select_list tr td{
		min-width:10px !important;
		text-align: left;
		padding:12px 5px;
	}
	.company_select_list tr{
		border-bottom: 1px solid #fff;
	}
	.company_select_list .cell.center{
		justify-content: center;
		display: flex;
	}
	.company_select_list tr::after{
		border-top: 1px solid #fff;
	}
	.van-nav-bar__left{
		font-size: 16px;
	}

	/* PC端响应式样式 */
	@media (min-width: 769px) {
		.company_select_mobile{
			display: none !important;
		}
		.company_select_dialog_list{
			max-height: 400px;
			overflow-y: auto;
		}
		.company_select_list_pc{
			width: 100%;
			border-collapse: collapse;
		}
		.company_select_list_pc thead th{
			text-align: left;
			padding: 10px 8px;
			border-bottom: 1px solid #ebeef5;
			font-size: 14px;
			color: #909399;
			font-weight: 500;
		}
		.company_select_list_pc tbody td{
			padding: 12px 8px;
			border-bottom: 1px solid #ebeef5;
			font-size: 16px;
		}
		.company_select_row{
			cursor: pointer;
			transition: background-color 0.15s;
		}
		.company_select_row:hover{
			background-color: #f5f7fa;
		}
		.company_select_empty td,
		.company_select_more td{
			padding: 20px 8px;
		}
		.pc_company_checkbox{
			width: 16px;
			height: 16px;
			border: 1px solid #dcdfe6;
			border-radius: 2px;
			display: inline-flex;
			align-items: center;
			justify-content: center;
			vertical-align: middle;
		}
		.pc_company_checkbox.is-checked{
			background-color: #027cfb;
			border-color: #027cfb;
		}
		.pc_company_checkbox.is-checked i{
			color: #fff;
			font-size: 12px;
		}
		.org_popup_mobile{
			display: none !important;
		}
	}
</style>
<style>
.company_select_plan .van-nav-bar__left{
	font-size:16px;
}
.org_select_dialog .el-dialog__header{
	border-bottom: 1px solid #ebeef5;
	padding-bottom: 16px;
}
.org_select_dialog .el-dialog__title{
	font-size: 18px;
	font-weight: 600;
}
.org_select_dialog .el-dialog__body{
	padding-top: 20px;
}
@media (min-width: 769px) {
	.org_popup_mobile{
		display: none !important;
	}
}
</style>